var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var toJSON = function (response) { return response.json(); };
/**
 * Either echos the input Response object if the response has content.
 * If the Response is empty, returns `null`.
 */
export function getNullWhenNoContent(res) {
    var length = res.headers.get('Content-Length');
    return res.status === 204 || length === '0' ? null : res;
}
/**
 * Given 2 functions, will return a function that executes either the first
 * ("success") or the second ("failure") based on whether or not the response
 * was "OK" (2xx or 3xx) status.
 */
export function withConditionalResponse(_a) {
    var _b = __read(_a, 2), a = _b[0], b = _b[1];
    return function (res) { return (res.ok ? a(res) : b(res)); };
}
//# sourceMappingURL=response.js.map